export default {
    TRACKING_URL: 'https://ratis.de/musterverfahren-ey-kostenrechner-thx/',
    MAX_COST_LIMIT: 30000000
}
